import { Map } from 'immutable';
import { CORROSION_LOG_ACTIONS as ACTIONS } from 'features/wells/corrosion/helpers/corrosionlogs.constants';

const initialState = Map({
  serviceProviders: [],
  corrosionMeasureTools: [],
  newServiceProvider: {},
  newCorrosionMeasureTool: {},
  corrosionLogsList: [],
  corrosionLogsFilters: [],
  compareFilesData: [],
});

const CorrosionLogReducer = (state = initialState, action) => {
  const { type, error, payload } = action;

  switch (type) {
    case ACTIONS.LOAD_SERVICE_PROVIDERS:
      if (error) return state;

      const serviceProviders = payload.map((provider) => ({
        name: provider.name,
        id: provider.serviceProviderId,
      }));

      return state.set('serviceProviders', serviceProviders);

    case ACTIONS.LOAD_CORROSION_MEASURE_TOOLS:
      if (error) return state;

      const corrosionMeasureTools = payload.map((tool) => ({
        name: tool.name,
        id: tool.corrosionMeasureToolId,
      }));

      return state.set('corrosionMeasureTools', corrosionMeasureTools);

    case ACTIONS.CREATE_NEW_SERVICE_PROVIDER:
      if (error) return state;

      return state.set('newServiceProvider', payload);

    case ACTIONS.CREATE_NEW_CORROSION_MEASURE_TOOL:
      if (error) return state;

      return state.set('newCorrosionMeasureTool', payload);

    case ACTIONS.LOAD_CORROSION_LOGS_LIST:
      if (error) return state;

      return state.set('corrosionLogsList', payload);

    case ACTIONS.LOAD_CORROSION_LOGS_FILTERS:
      if (error) return true;

      return state.set('corrosionLogsFilters', payload);

    case ACTIONS.LOAD_COMPARE_FILES_DATA:
      if (error) return true;

      return state.set('compareFilesData', payload);

    default:
      return state;
  }
};

export default CorrosionLogReducer;
